import { useCallback } from "react";
import { isEmpty } from "lodash";
import useAcademicSessionApi from "@services/api/academicSession/academicSession.api";
import { AcademicSessionProps } from "@services/api/academicSession/academicSession.types";
import useYears from "./years.hook";

export default function usePeriod() {
  const { usePageQuery } = useAcademicSessionApi();
  const { data: fetchedAcademicSession } = usePageQuery({
    variables: {
      sort: ["startDate", "endDate", "code"],
      size: 9999
    }
  });

  const { getYear } = useYears();
  const getPeriods = useCallback(
    (yearExternalId?: string) =>
      fetchedAcademicSession?.content.filter(
        (period) =>
          period.year.externalId === getYear(yearExternalId)?.externalId
      ) as AcademicSessionProps[],
    [getYear, fetchedAcademicSession]
  );

  const getPeriodSequence = useCallback(
    (periods: AcademicSessionProps[], externalId: string | undefined) => {
      if (!isEmpty(externalId)) {
        return periods.findIndex((period) => period.externalId === externalId);
      }
      return -1;
    },
    []
  );

  return {
    periods: fetchedAcademicSession,
    getPeriods,
    getPeriodSequence
  };
}
